import { useEffect } from 'react'

export const CONTACT_ID = 'contact'
export const CONTACT_FIRST_FIELD_ID = 'contact-name'

/**
 * Every link to #contact scrolls the hero form into view (below the sticky header,
 * via html scroll-padding-top) and places focus in the Name field in the same motion,
 * using preventScroll so there is no second jump.
 */
export function useContactAnchor() {
  useEffect(() => {
    const goToForm = () => {
      const wrapper = document.getElementById(CONTACT_ID)
      const field = document.getElementById(CONTACT_FIRST_FIELD_ID) as HTMLInputElement | null
      if (!wrapper) return
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      wrapper.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' })
      field?.focus({ preventScroll: true })
      if (window.location.hash !== `#${CONTACT_ID}`) {
        window.history.replaceState(null, '', `#${CONTACT_ID}`)
      }
    }

    const onClick = (e: MouseEvent) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
      const target = e.target as Element | null
      const link = target?.closest(`a[href="#${CONTACT_ID}"]`)
      if (!link) return
      e.preventDefault()
      goToForm()
    }

    document.addEventListener('click', onClick)
    return () => document.removeEventListener('click', onClick)
  }, [])
}
